// extracted by mini-css-extract-plugin
module.exports = {"autocomplete":"_2YyoHMntxlB2w9rDcmwnkt"};